import { Injectable, inject } from '@angular/core';
import { StorageV2Service, StoreV2Map } from '@schenck/rotec-components';
import { PaginatedRotorTypeData } from 'src/utils/interfaces/rotor-type.interfaces';

@Injectable()
export class RotorSelectInfoService extends StoreV2Map<PaginatedRotorTypeData> {
  constructor() {
    const storageService = inject(StorageV2Service);

    super('RotorSelectService', { name: 'RotorSelectService', storageService });
  }

  /**
   * Adds a new rotor to the memory
   */
  addRotor(rotor: PaginatedRotorTypeData) {
    const rotors = this.state;
    rotors[rotor.id] = rotor;
    this.patchState('add rotor', rotors);
  }

  /**
   * Removes a rotor from the comparison.
   */
  removeRotor(id: string) {
    delete this.state[id];
    this.patchState('remove rotor', { ...this.state });
  }

  /**
   * Removes all rotors.
   */
  clearAll() {
    this.patchState('clear all', {});
  }
}
